import React from "react";
import { useLocation } from "react-router-dom";
import FormStafClinicComponent from "../../FormStafClinicComponent";

export default function DetailStafClinic() {
  const location = useLocation();

  return <FormStafClinicComponent isView initialValues={location?.state} />;
}
